"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useRef } from "react";
import type SwiperCore from "swiper";
import type { ExperienceTour } from "@/lib/navigation";
import ExperienceCard from "@/app/(main)/components/ExperienceCard";

import "swiper/css";
import "swiper/css/navigation";

export default function ExperienceSlider({
  tours,
}: {
  tours: ExperienceTour[];
}) {
  const swiperRef = useRef<SwiperCore | null>(null);

  return (
    <div className="destination-area13 bg-smoke position-relative overflow-hidden space">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Wonderful Central Holidays</span>
          <h2 className="sec-title">Explore Top Experiences</h2>
        </div>
        <div className="slider-area">
          <Swiper
            className="th-slider destination-slider13 slider-drag-wrap"
            modules={[Navigation]}
            loop={true}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1300: { slidesPerView: 5, centeredSlides: false },
            }}
          >
            {tours.map((tour, i) => (
              <SwiperSlide key={tour.id}>
                <ExperienceCard tour={tour} index={i} />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="icon-box mt-60 text-center">
            <button
              className="slider-arrow style6 default"
              onClick={() => swiperRef.current?.slidePrev()}
            >
              <Image
                src="/main/img/icon/right-arrow2.svg"
                alt=""
                width={24}
                height={24}
              />
            </button>
            <button
              className="slider-arrow style6 default"
              onClick={() => swiperRef.current?.slideNext()}
            >
              <Image
                src="/main/img/icon/left-arrow2.svg"
                alt=""
                width={24}
                height={24}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
